export default __webpack_public_path__ + "static/strapi-34d94fae66f20e5aa7c70983c7866ff7.png";